import { Injectable, signal } from '@angular/core';

export interface NotificationItem {
  id: string;
  title: string;
  message: string;
  createdAt: string;
  read: boolean;
}

/**
 * STUB — o feed real de notificações ainda não existe (ver issue #45).
 * Contador e lista já ficam expostos como signals prontos para popular
 * quando o endpoint real existir; NotificationMenuComponent não deve
 * mostrar valor fixo, sempre lendo daqui.
 */
@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly _items = signal<NotificationItem[]>([]);
  private readonly _unreadCount = signal(0);

  readonly items = this._items.asReadonly();
  readonly unreadCount = this._unreadCount.asReadonly();

  setUnreadCount(count: number): void {
    this._unreadCount.set(count);
  }

  clear(): void {
    this._items.set([]);
    this._unreadCount.set(0);
  }
}
